const alarmEvent = {
  bindings: {
    isActive: '<',
  },
  templateUrl: '/modules/analysis/alarm-event/alarm-event.html',
  controller: 'AlarmEventController',
};

angular
  .module('analysis.module')
  .component('alarmEventTab', alarmEvent);
